module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst langCode = (((storage || {}).user || {}).data || {}).langCode || 'de-at'\nconst eventTS = ((((resourceData || {}).data || {}).attributes || {}).event || {}).startTS\nconst eventPart = ((((resourceData || {}).data || {}).attributes || {}).eventParts || {})[langCode] || {}\nconst path = eventPart.path\nlet durationText = ''\nif(eventTS){\nconst duration = utils.moment.duration(utils.moment(eventTS).diff(utils.moment()))\nconst durations = {}\ndurations.weeks = Math.floor(duration.as('weeks'))\ndurations.days  = Math.floor(duration.subtract(durations.weeks, 'weeks').as('days'))\ndurations.hours = Math.floor(duration.subtract(durations.days, 'days').as('hours'))\ndurationText = __('events.nextEventTimer.duration', durations)\n} else {\ndurationText = __('events.nextEventTimer.emptyDuration')\n}\n%><div>\n<h2><%= __('events.nextEventTimer.headline') %></h2>\n<div class=\"timer\"><%- durationText %></div><%\nif(path){\n%><a href=\"<%- path %>\" class=\"linkToEvent\">Zum Event &gt;&gt;</a><%\n}\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\bootstrap5\\events\\nextEventTimer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const langCode = (((storage || {}).user || {}).data || {}).langCode || 'de-at'
const eventTS = ((((resourceData || {}).data || {}).attributes || {}).event || {}).startTS
const eventPart = ((((resourceData || {}).data || {}).attributes || {}).eventParts || {})[langCode] || {}
const path = eventPart.path
let durationText = ''
if(eventTS){
const duration = utils.moment.duration(utils.moment(eventTS).diff(utils.moment()))
const durations = {}
durations.weeks = Math.floor(duration.as('weeks'))
durations.days  = Math.floor(duration.subtract(durations.weeks, 'weeks').as('days'))
durations.hours = Math.floor(duration.subtract(durations.days, 'days').as('hours'))
durationText = __('events.nextEventTimer.duration', durations)
} else {
durationText = __('events.nextEventTimer.emptyDuration')
}

    ; __line = 17
    ; __append("<div>\n<h2>")
    ; __line = 18
    ; __append(escapeFn( __('events.nextEventTimer.headline') ))
    ; __append("</h2>\n<div class=\"timer\">")
    ; __line = 19
    ; __append( durationText )
    ; __append("</div>")
    ; 
if(path){

    ; __line = 21
    ; __append("<a href=\"")
    ; __append( path )
    ; __append("\" class=\"linkToEvent\">Zum Event &gt;&gt;</a>")
    ; 
}

    ; __line = 23
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\bootstrap5\events\nextEventTimer.ejs

}